import { BaseApi } from "./Base";

class IntegrationApi extends BaseApi {
  getAll() {
    return super.getApiRequest("/integrations");
  }

  save(type, config) {
    return super.putApiRequest("/integrations", { type, ...config });
  }

  verify(type, payload) {
    return super.postApiRequest("/integrations/verify", { type, ...payload });
  }
}

const integrationApi = new IntegrationApi();

export default integrationApi;
